// extracted by mini-css-extract-plugin
module.exports = {"stock-navigator":"_1RJ_a_SWHrZg4-O8wI-Es8"};